export default function Footer() {
    return (
        <div className="py-3">
            <div className="text-center">
                <h1 className="text-md text-black/90 dark:text-white duration-500">&copy; {new Date().getFullYear() === 2022 ? 2022 : `2022 - ${new Date().getFullYear()}`} <span className="font-normal text-gray-700 dark:text-gray-300">thespeeds.co</span></h1>
            </div>
        </div>
    )
}